import React, { useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { MenuItem, Toolbar, Drawer, Divider, Badge } from '@material-ui/core';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import { useLocation } from 'react-router-dom';
import { get } from 'react-hook-form';

import { Box, PageHeader } from 'components';
import { RootState } from 'redux-modules/store/rootState';
import history from 'common/utils/history';
import {
  Logo,
  MenuDash,
  PortfolioActiveIcon,
  PortfolioIcon,
  DashboardIcon,
  DashboardActiveIcon,
  InvestIcon,
  InvestActiveIcon,
  DollerActiveIcon,
  DollerIcon,
  TransactionActiveIcon,
  TransactionIcon,
  referAndEarnIcon,
  referAndEarnActiveIcon,
} from 'assets';

import styles from './styles';

const NavBar = () => {
  const classes = styles();

  const { name } = useSelector(({ Auth }: RootState) => Auth.user);
  const { investor } = useSelector(({ Investor }: RootState) => Investor);

  const componentMounted = useRef(true);
  const pathName = useLocation().pathname;
  const [active, setActive] = useState('');
  const [state, setState] = useState({
    mobileView: false,
    drawerOpen: false,
  });
  const { mobileView, drawerOpen } = state;

  const getRoutes = () => {
    const Routes = [
      {
        name: 'Dashboard',
        link: '/dashboard',
        key: 'dashboard',
        activeImg: DashboardActiveIcon,
        img: DashboardIcon,
      },
      {
        name: 'Deals',
        link: '/deals',
        key: 'deals',
        activeImg: InvestActiveIcon,
        img: InvestIcon,
      },
      {
        name: 'Invest Now',
        link: '/invest-now',
        key: 'invest-now',
        activeImg: DollerActiveIcon,
        img: DollerIcon,
      },
      {
        name: 'Portfolio',
        link: '/portfolio',
        key: 'portfolio',
        activeImg: PortfolioActiveIcon,
        img: PortfolioIcon,
      },
      {
        name: 'Transactions',
        link: '/transactions',
        key: 'transactions',
        activeImg: TransactionActiveIcon,
        img: TransactionIcon,
      },
      {
        name: 'Documents',
        link: '/profile/document',
        key: 'document',
        activeImg: InvestActiveIcon,
        img: InvestIcon,
      },
      {
        name: 'Refer & Earn',
        link: '/refer',
        key: 'refer',
        activeImg: referAndEarnActiveIcon,
        img: referAndEarnIcon,
      },
    ];
    if (get(investor, 'reviewed')) {
      return Routes;
    } else {
      return Routes.filter((item) => {
        return ['dashboard', 'deals'].includes(item.key);
      });
    }
  };

  useEffect(() => {
    if (pathName) {
      const activeItem = pathName.split('/')[pathName.split('/').length - 1];
      setActive(activeItem);
    }
  }, [pathName]);

  useEffect(() => {
    const setResponsiveness = () => {
      if (componentMounted.current) {
        return window.innerWidth < 1025
          ? setState((prevState) => ({ ...prevState, mobileView: true }))
          : setState((prevState) => ({ ...prevState, mobileView: false }));
      }
      return;
    };

    setResponsiveness();

    window.addEventListener('resize', () => setResponsiveness());

    return () => {
      window.removeEventListener('resize', () => setResponsiveness());
      componentMounted.current = false;
    };
  }, []);

  const displayMobile = () => {
    const handleDrawerOpen = () =>
      setState((prevState) => ({ ...prevState, drawerOpen: true }));
    const handleDrawerClose = () =>
      setState((prevState) => ({ ...prevState, drawerOpen: false }));

    return (
      <Toolbar className={classes.toolbarBox}>
        <Drawer
          className={classes.drawer}
          {...{
            anchor: 'left',
            open: drawerOpen,
            onClose: handleDrawerClose,
          }}
        >
          <Box className={classes.drawerContent}>
            <Box className={classes.drawerHeader}>
              <ArrowBackIosIcon
                className={classes.rightIcon}
                onClick={handleDrawerClose}
              />
            </Box>
            <Divider />
            <Box className={classes.linksInfo}>
              {/* {userInfo()} */}
              {getRoutes().map((i) => {
                return (
                  <MenuItem
                    className={
                      active === i.key.toLowerCase()
                        ? classes.activeMenuItem
                        : classes.menuItem
                    }
                    key={i.name}
                    onClick={() => {
                      if (i.key === 'contact-us') {
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore
                        window.Intercom('show');
                      } else {
                        history.push(i.link);
                      }
                    }}
                  >
                    <>
                      {active === i.key.toLowerCase() ? (
                        <img
                          src={i.activeImg}
                          alt={i.activeImg}
                          className={classes.protifoImg}
                        />
                      ) : (
                        <img
                          src={i.img}
                          alt={i.img}
                          className={classes.protifoImg}
                        />
                      )}
                    </>
                    {i.name}
                    <Badge
                      className={classes.brageAccount}
                      overlap="circular"
                      color="secondary"
                    ></Badge>
                  </MenuItem>
                );
              })}
              <PageHeader name={name} />
            </Box>
          </Box>
        </Drawer>

        <Box>{LogoImg()}</Box>
        <img
          src={MenuDash}
          alt={MenuDash}
          className={classes.menuDash}
          {...{
            onClick: handleDrawerOpen,
          }}
        />
      </Toolbar>
    );
  };

  const displayDesktop = () => {
    return (
      <Toolbar className={classes.dashLeftContent}>
        {LogoImg()}
        <Box className={classes.linksInfo}>
          <Box className={classes.leftLinks}>
            {getRoutes().map((i) => {
              return (
                <MenuItem
                  className={
                    active === i.key.toLowerCase()
                      ? classes.activeMenuItem
                      : classes.menuItem
                  }
                  key={i.name}
                  onClick={() => {
                    if (i.key === 'contact-us') {
                      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                      // @ts-ignore
                      window.Intercom('show');
                    } else {
                      history.push(i.link);
                    }
                  }}
                >
                  {/* {i.icon} {''} */}
                  <>
                    {active === i.key.toLowerCase() ? (
                      <img
                        src={i.activeImg}
                        alt={i.activeImg}
                        className={classes.protifoImg}
                      />
                    ) : (
                      <img
                        src={i.img}
                        alt={i.img}
                        className={classes.protifoImg}
                      />
                    )}
                  </>
                  {i.name}
                  <Badge
                    className={classes.brageAccount}
                    overlap="circular"
                    color="secondary"
                  ></Badge>
                </MenuItem>
              );
            })}
          </Box>
        </Box>
        {/* {Buttons()} */}
      </Toolbar>
    );
  };

  const LogoImg = () => {
    return (
      <Box className={classes.dashLogo}>
        <img src={Logo} alt={Logo} className={classes.logoImg} />
      </Box>
    );
  };

  // const userInfo = () => {
  //   return (
  //     <Box className={classes.dashAvatarLogo}>
  //       {/* <Avatar className={classes.iconStyleOne}>s</Avatar> */}
  //       <Typography
  //         variant="h4"
  //         gutterBottom
  //         className={classes.labelFundUpHead}
  //       >
  //         {user.name}
  //       </Typography>
  //       <Typography
  //         variant="caption"
  //         gutterBottom
  //         className={classes.labelStartUpText}
  //       >
  //         {user.email}
  //       </Typography>
  //     </Box>
  //   );
  // };

  return <>{mobileView ? displayMobile() : displayDesktop()}</>;
};
export default NavBar;
